import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { selectedTagsI } from '@/pages/ProfessionPage/SearchBox'

interface setCompareTagsListI {
  keyword: string
  tagsList: selectedTagsI
}

const initialState: setCompareTagsListI = {
  keyword: '',
  tagsList: {
    主题: [],
    朝代: [],
    类型: [],
    材质: [],
    形制: [],
    画派: []
  }
}

export const setCompareTagsListSlice = createSlice({
  name: 'setCompareTagsListSlice',
  initialState,
  reducers: {
    setCompareKeyword: (state, action: PayloadAction<string>) => {
      state.keyword = action.payload
    },
    setCompareTagsList: (state, action: PayloadAction<selectedTagsI>) => {
      state.tagsList = action.payload
    }
  }
})
export const { setCompareKeyword, setCompareTagsList } = setCompareTagsListSlice.actions
export default setCompareTagsListSlice.reducer
